import React, { Component } from 'react';
import { func, number } from 'prop-types';
import './JobPricingSummaryHeader.scss';

class JobPricingSummaryHeader extends Component {
  static propTypes = {
    onClick: func,
    selectedJobs: number
  };

  render() {
    const { onClick, selectedJobs, hideSlideout } = this.props;
    const jobsDisplayText = selectedJobs === 1 ? 'job' : 'jobs';

    return (
      <div className="summary-header">
        <a className="summary-header__link" onClick={onClick}>
          <i className="icon-reply" />
          Return to select jobs
        </a>
        <div className="summary-header__title-container">
          <div className="summary-header__title">
            Job Pricing Summary
            <span className="summary-header__subtitle">
              {selectedJobs} {jobsDisplayText} selected
            </span>
          </div>
        </div>
      </div>
    );
  }
}

export default JobPricingSummaryHeader;
